export default "__VITE_ASSET__104b112b__"